import * as React from 'react';
import { Input, Tag, Tooltip } from 'antd';
import './style/index.less';
import { cloneDeep } from 'lodash';

interface NiTagsInputProps {
  className?: string;
  value: string[];
  hideBorder?: boolean;
  placeholder?: string;
  onChange?: (args: any[]) => void;
  onBlur?: () => void;
  disabled?: boolean;
}

interface NiTagsInputState {
  focus: boolean;
  inputValue: string;
}

export class NiTagsInput extends React.Component<
  NiTagsInputProps,
  NiTagsInputState
> {
  public state: NiTagsInputState = {
    focus: false,
    inputValue: ''
  };
  private input: any;
  saveInputRef = (input: any) => (this.input = input);

  private isMouseOut = true;
  render() {
    const state = this.state;
    const props = this.props;
    const { value = [] } = props;
    const { inputValue } = state;

    return (
      <div
        className={`ni-tags-input-wrap ${props.className} ${props.hideBorder ? 'no-border' : ''} ${props.disabled ? 'disabled' : ''}`}
        onBlur={() => {
          if (this.isMouseOut) {
            this.handleInputBlur();
          }
        }}
        onMouseUp={() => {
          if (this.input) {
            this.input.focus();
          }
        }}
        onMouseOut={() => {
          this.isMouseOut = true;
        }}
        onMouseOver={() => {
          this.isMouseOut = false;
        }}
      >
        {!state.focus ? (
          <p
            className={`blur-render`}
            onClick={() => {
              if (props.disabled) {
                return;
              }

              this.setState(
                {
                  focus: true,
                  inputValue: ''
                },
                () => {
                  if (this.input) {
                    this.input.focus();
                  }
                }
              );
            }}
          >
            {((value as string[]) || []).length <= 0 ? (
              <span className="placeholder">{props.placeholder}</span>
            ) : (
              value.join(',')
            )}
          </p>
        ) : (
          <div className={`ni-tag-input-box`}>
            {value.map((tag, index) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag
                  key={tag}
                  closable={!props.disabled}
                  onClose={() => this.handleTagDeletRemove(tag)}
                >
                  {tag}
                </Tag>
              );

              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
            <Input
              disabled={props.disabled}
              type="text"
              size="small"
              ref={this.saveInputRef}
              // style={{ width: 80 }}
              value={inputValue}
              onChange={this.handleInputChange}
              onPressEnter={this.handleInputConfirm}
            />
          </div>
        )}
      </div>
    );
  }

  handleInputChange = (e: any) => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputBlur = () => {
    this.setState({
      focus: false
    });

    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    const { value = [], onChange } = this.props;

    if (!inputValue || value.indexOf(inputValue) >= 0) {
      return;
    }

    const next = cloneDeep(value);
    next.push(inputValue);

    if (onChange) {
      onChange(next);
    }

    this.setState({
      inputValue: ''
    });
  };

  handleTagDeletRemove = (removeTag: any) => {
    const { value = [] } = this.props;
    const next = value.filter((it: any) => {
      return !(it === removeTag);
    });
    if (this.props.onChange) {
      this.props.onChange(next);
    }
  };
}
